import { Link } from "react-router-dom";
import { FaGithub, FaLinkedin } from "react-icons/fa";
import { commonData, content } from "../data";
import "./navbar.css";

function Navbar({ lang, setLang }) {
  const t = content[lang].navbar;
  const { personal } = commonData;

  return (
    <nav className="navbar">
      <div className="container nav-container">
        <Link to="/" className="nav-logo" aria-label="Burak Karahan Home">
          <img src="/logo-brand.svg" alt="Burak Karahan" className="nav-logo-icon" />
        </Link>

        <div className="nav-links">
          <Link to="/" className="nav-link">{t.home}</Link>
          <Link to="/contact" className="nav-link">{t.contact}</Link>
        </div>

        <div className="nav-socials">
          <div className="nav-lang-switcher" role="tablist" aria-label="Dil Seçimi">
            <button
              className={`nav-lang-btn ${lang === "tr" ? "active" : ""}`}
              onClick={() => setLang("tr")}
              type="button"
            >
              TR
            </button>
            <button
              className={`nav-lang-btn ${lang === "en" ? "active" : ""}`}
              onClick={() => setLang("en")}
              type="button"
            >
              EN
            </button>
          </div>

          <a href={personal.github} target="_blank" rel="noreferrer" className="social-icon">
            <FaGithub />
          </a>
          <a href={personal.linkedin} target="_blank" rel="noreferrer" className="social-icon">
            <FaLinkedin />
          </a>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;